import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Nav } from "./landing/Nav";
import { Hero } from "./landing/Hero";
import { SampleAnalysis } from "./landing/SampleAnalysis";
import { AnomalyCatalog } from "./landing/AnomalyCatalog";
import { Pipeline } from "./landing/Pipeline";
import { Drones } from "./landing/Drones";
import { Timeline } from "./landing/Timeline";
import { Stats } from "./landing/Stats";
import { Pricing } from "./landing/Pricing";
import { FinalCta } from "./landing/FinalCta";
import { Footer } from "./landing/Footer";

/**
 * Marketing landing for ultrascan.ai. The Express SPA catchall serves
 * landing's build for any path that isn't /v1/*, /api/*, /admin/api/*,
 * /health, or /readyz — so the React Router catchall here mirrors that
 * by rendering the marketing tree for unknown paths.
 *
 * Design: "Field Instrument" — see apps/landing/src/index.css for the
 * design tokens and signature motifs (bracketed section numbers,
 * mono technical labels, L-corner brackets, scan-line animation,
 * topographic background patterns).
 */
export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketingApp />} />
        <Route path="*" element={<MarketingApp />} />
      </Routes>
    </BrowserRouter>
  );
}

function MarketingApp() {
  return (
    <div className="relative overflow-x-clip">
      <Nav />
      <Hero />
      <SampleAnalysis />
      <AnomalyCatalog />
      <Pipeline />
      <Drones />
      <Timeline />
      <Stats />
      <Pricing />
      <FinalCta />
      <Footer />
    </div>
  );
}
